import React from 'react';
import './Icon.scss';

const Icon = props => {
    const classes = 'Icon ' + props.className;

    return (
        <div className={classes}>
            {props.children}
        </div>
    );
}



export default Icon;
